// extracted by mini-css-extract-plugin
export default {"page_favorites":"Favorites_page_favorites__RadGh"};